import { ToastOptions } from "react-toastify";

export const settings: ToastOptions<{}> = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
  theme: "light",
};
